// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__twaGH","requiredAsterisk":"Info_requiredAsterisk__2k639"};